
import React from "react";
import PropTypes from "prop-types";

import { format } from "d3-format";
import { timeFormat } from "d3-time-format";
import '../../css/ChartIntraday.css';

import { ChartCanvas, Chart } from "react-stockcharts";
import {
	// BarSeries,
	CandlestickSeries,
} from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import {
	// CrossHairCursor,
	// EdgeIndicator,
	// CurrentCoordinate,
	MouseCoordinateX,
	MouseCoordinateY,
} from "react-stockcharts/lib/coordinates";

import { discontinuousTimeScaleProvider } from "react-stockcharts/lib/scale";
// import { OHLCTooltip } from "react-stockcharts/lib/tooltip";
import { fitWidth } from "react-stockcharts/lib/helper";
import { last } from "react-stockcharts/lib/utils";

class ChartIntraday extends React.Component {
	render() {
		const { type, data: initialData, width, ratio } = this.props;

		const xScaleProvider = discontinuousTimeScaleProvider
			.inputDateAccessor(d => d.date);
		const {
			data,
			xScale,
			xAccessor,
			displayXAccessor,
		} = xScaleProvider(initialData);

		const start = xAccessor(last(data));
		let end = xAccessor(data[Math.max(0, data.length - 150)]);		
		if (data !== undefined && data.length <= 20) { 
			end = -20;
		} else if (data !== undefined && data.length > 20) { 
			end = -5;
		} 

		console.log('chartintraday', start, end, ratio, displayXAccessor, data.length);
		const xExtents = [start, end];

		const gridMargin = { left: 40, right: 70, top: 20, bottom: 30 };
		//const gridMargin = margin;
		const gridHeight = 200 - gridMargin.top - gridMargin.bottom;
		const gridWidth = width - gridMargin.left - gridMargin.right;
		const showGrid = true;
		const yGrid = showGrid ? { innerTickSize: -1 * gridWidth, tickStrokeOpacity: 0.2 } : {};
		const xGrid = showGrid ? { innerTickSize: -1 * gridHeight, tickStrokeOpacity: 0.2 } : {};

		return (
			<ChartCanvas height={200}
				ratio={ratio}
				width={width}
				margin={{ left: 30, right: 80, top: 10, bottom: 30 }}
				type={type}
				seriesName=""
				data={data}
				xScale={xScale}
				xAccessor={xAccessor}
				displayXAccessor={displayXAccessor}
				xExtents={xExtents}
			>
				{/* <Chart id={2}
					yExtents={[d => d.volume]}
					height={150} origin={(w, h) => [0, h - 150]}
				>

					<YAxis axisAt="left" orient="left" ticks={5} tickFormat={format(".2s")}/>

					<MouseCoordinateY
						at="left"
						orient="left"
						displayFormat={format(".4s")} />

					<BarSeries yAccessor={d => d.volume} fill={d => d.close > d.open ? "#6BA583" : "#FF0000"} />

					<CurrentCoordinate yAccessor={d => d.volume} fill="#9B0A47" />

					<EdgeIndicator itemType="last" orient="right" edgeAt="right"
						yAccessor={d => d.volume} displayFormat={format(".4s")} fill="#0F0F0F"/>
				</Chart> */}
				<Chart id={1}
					yExtents={[d => [d.high, d.low]]}
					padding={{ top: 40, bottom: 20 }}
				>
					<XAxis axisAt="bottom" orient="bottom" ticks={3} {...xGrid}/>
					<YAxis axisAt="right" orient="right" ticks={5} {...yGrid}/>

					<MouseCoordinateX
						rectWidth={40}
						at="bottom"
						orient="bottom"
						displayFormat={timeFormat("%H:%M")} />
					<MouseCoordinateY
						rectWidth={50}
						at="right"
						orient="right"
						displayFormat={format(".0f")} />

					<CandlestickSeries />
					{/* <EdgeIndicator itemType="last" orient="right" edgeAt="right"
						yAccessor={d => d.close} fill={d => d.close > d.open ? "#6BA583" : "#FF0000"} displayFormat={format('.0f')}/> */}

					{/* <OHLCTooltip origin={[-70, -5]} xDisplayFormat={timeFormat("%Y-%m-%d %H:%M:%S")}/> */}
				</Chart>
				{/* <CrossHairCursor /> */}
			</ChartCanvas>
		);
	}
}

ChartIntraday.propTypes = {
	data: PropTypes.array.isRequired,
	width: PropTypes.number.isRequired,
	ratio: PropTypes.number.isRequired,
	type: PropTypes.oneOf(["svg", "hybrid"]).isRequired,
};

ChartIntraday.defaultProps = {
	type: "svg",
};
ChartIntraday = fitWidth(ChartIntraday);

export default ChartIntraday;